import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const EyeFilled: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.62094 3.887C4.82127 2.92628 6.32826 2.10715 8 2.10715C9.67174 2.10715 11.1787 2.92628 12.379 3.887C13.5858 4.85285 14.5402 6.00781 15.1174 6.78269L15.1218 6.78866C15.372 7.13454 15.5 7.5666 15.5 8C15.5 8.43341 15.372 8.86544 15.1218 9.21132L15.1174 9.21735C14.5402 9.99223 13.5858 11.1472 12.379 12.113C11.1787 13.0738 9.67174 13.8929 8 13.8929C6.32826 13.8929 4.82127 13.0738 3.62094 12.113C2.41421 11.1472 1.45975 9.9922 0.882636 9.21732L0.87819 9.21135C0.627988 8.86547 0.5 8.43341 0.5 8C0.5 7.5666 0.628029 7.13457 0.878231 6.78869L0.882594 6.78266C1.45971 6.00778 2.41421 4.85285 3.62094 3.887ZM10.4107 8C10.4107 9.3314 9.3314 10.4107 8 10.4107C6.6686 10.4107 5.58929 9.3314 5.58929 8C5.58929 6.6686 6.6686 5.58929 8 5.58929C9.3314 5.58929 10.4107 6.6686 10.4107 8Z"
      fill="currentColor"
    />
  </svg>
);
